import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, Menu, MenuItem, Tooltip, Box, Typography } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import CheckIcon from '@mui/icons-material/Check';
import Flag from 'react-world-flags';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    handleClose();
  };

  const currentLanguage = i18n.language;

  return (
    <>
      <Tooltip title="Change Language">
        <IconButton
          onClick={handleClick}
          color="inherit"
          sx={{ position: 'absolute', right: 16, top: 16 }}
        >
          <LanguageIcon />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {/* English Option */}
        <MenuItem onClick={() => changeLanguage('en')} selected={currentLanguage === 'en'}>
          <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
            <Box display="flex" alignItems="center">
              <Flag code="gb" style={{ width: 24, height: 16, marginRight: 8 }} />
              <Typography>English</Typography>
            </Box>
            {currentLanguage === 'en' && <CheckIcon fontSize="small" />}
          </Box>
        </MenuItem>

        {/* Slovak Option */}
        <MenuItem onClick={() => changeLanguage('sk')} selected={currentLanguage === 'sk'}>
          <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
            <Box display="flex" alignItems="center">
              <Flag code="sk" style={{ width: 24, height: 16, marginRight: 8 }} />
              <Typography>Slovak</Typography>
            </Box>
            {currentLanguage === 'sk' && <CheckIcon fontSize="small" />}
          </Box>
        </MenuItem>
      </Menu>
    </>
  );
};

export default LanguageSwitcher;
